import { defineStore } from "pinia";
import Services from '@/services/sutting/bodySideServices'
import { mapList, mapBodySide } from '@/helpers/mapFuncs'

export const useBodySideStore = defineStore("bodySide", {
persist: true,
state:()=>({
    bodySide: {},
    bodySides: [],
}),
getters : {
    getBodySide() {
        return mapBodySide(this.bodySide)
    },
    getBodySides() {
        return this.bodySides.map(mapBodySide)
    },
    getBodySidesList() {
        return this.bodySides.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setBodySide(bodySide) {
        this.bodySide = bodySide
    },
    setBodySides(bodySides) {
        this.bodySides = bodySides
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setBodySide(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setBodySides(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.bodySides.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.bodySides[this.bodySides.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.bodySides = this.bodySides.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
